<template>
  <van-nav-bar  :title="title" @click-left="onClickLeft" :left-arrow="showLeftIcon">
    <template #left v-if="showLeftIcon">
      <van-icon class="arrow-left" name="arrow-left" size="20" />
    </template>
  </van-nav-bar>
</template>
<script>
export default {
  name: "Head",
  props: ['title','showLeftIcon'],

  data () {
    return {
    };
  },

  methods: {
    onClickLeft () {
      console.log(this.showLeftIcon,'wwwwwwwwww')
      if(this.showLeftIcon){
        this.$router.back()
        }

    }
  }
}
</script>
<style lang="less" scoped>
.van-nav-bar__left .arrow-left {
  color: #000;
}
</style>
